// 本体の既存階層はコンフリクト対策で移動しない.新しいファイルを追加する場合もそちらへ.
// TODO: 将来的にはできれば移行を検討する事.
export * from "../../../../domain/format";
// 今はdocument下に存在するが、format下にあるべき.(文書固有ではないので.)
// 本体の修正するとH大向け修正でコンフリクトしそうなので、一旦参照で回避.
// TODO: 見直せるタイミングで階層変更したい.
export {
  DocumentKind,
} from "../../../../domain/document";
